import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-atlantic/react-atlantic/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { ProgressBar, ProgressCircle } from './view';
import { WrapperVertical, WrapperHorizontal } from '../../gatsby-theme-docz/components/Wrapper';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "progress"
    }}>{`Progress`}</h1>
    <p>{`Components to display progress state.`}</p>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <h3 {...{
      "id": "bar"
    }}>{`Bar`}</h3>
    <Playground __position={0} __code={'<ProgressBar value={0} />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      ProgressBar,
      ProgressCircle,
      WrapperVertical,
      WrapperHorizontal,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <ProgressBar value={0} mdxType="ProgressBar" />
    </Playground>
    <h3 {...{
      "id": "circle"
    }}>{`Circle`}</h3>
    <Playground __position={1} __code={'<ProgressCircle value={0} />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      ProgressBar,
      ProgressCircle,
      WrapperVertical,
      WrapperHorizontal,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <ProgressCircle value={0} mdxType="ProgressCircle" />
    </Playground>
    <h2 {...{
      "id": "progress-bar"
    }}>{`Progress bar`}</h2>
    <Playground __position={2} __code={'<WrapperVertical>\n  <ProgressBar value={0} />\n  <ProgressBar value={25} />\n  <ProgressBar value={50} />\n  <ProgressBar value={75} />\n  <ProgressBar value={100} />\n</WrapperVertical>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      ProgressBar,
      ProgressCircle,
      WrapperVertical,
      WrapperHorizontal,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <WrapperVertical mdxType="WrapperVertical">
        <ProgressBar value={0} mdxType="ProgressBar" />
        <ProgressBar value={25} mdxType="ProgressBar" />
        <ProgressBar value={50} mdxType="ProgressBar" />
        <ProgressBar value={75} mdxType="ProgressBar" />
        <ProgressBar value={100} mdxType="ProgressBar" />
    </WrapperVertical>
    </Playground>
    <h2 {...{
      "id": "progress-circle"
    }}>{`Progress circle`}</h2>
    <Playground __position={3} __code={'<WrapperHorizontal>\n  <ProgressCircle value={0} />\n  <ProgressCircle value={25} />\n  <ProgressCircle value={50} />\n  <ProgressCircle value={75} />\n  <ProgressCircle value={100} />\n</WrapperHorizontal>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      ProgressBar,
      ProgressCircle,
      WrapperVertical,
      WrapperHorizontal,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <WrapperHorizontal mdxType="WrapperHorizontal">
        <ProgressCircle value={0} mdxType="ProgressCircle" />
        <ProgressCircle value={25} mdxType="ProgressCircle" />
        <ProgressCircle value={50} mdxType="ProgressCircle" />
        <ProgressCircle value={75} mdxType="ProgressCircle" />
        <ProgressCircle value={100} mdxType="ProgressCircle" />
    </WrapperHorizontal>
    </Playground>
    <h2 {...{
      "id": "complete"
    }}>{`Complete`}</h2>
    <h3 {...{
      "id": "bar-1"
    }}>{`Bar`}</h3>
    <Playground __position={4} __code={'<ProgressBar value={100} />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      ProgressBar,
      ProgressCircle,
      WrapperVertical,
      WrapperHorizontal,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <ProgressBar value={100} mdxType="ProgressBar" />
    </Playground>
    <h3 {...{
      "id": "circle-1"
    }}>{`Circle`}</h3>
    <Playground __position={5} __code={'<ProgressCircle value={100} />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      ProgressBar,
      ProgressCircle,
      WrapperVertical,
      WrapperHorizontal,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <ProgressCircle value={100} mdxType="ProgressCircle" />
    </Playground>
    <h2 {...{
      "id": "failed"
    }}>{`Failed`}</h2>
    <h3 {...{
      "id": "bar-2"
    }}>{`Bar`}</h3>
    <Playground __position={6} __code={'<ProgressBar value={100} failed />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      ProgressBar,
      ProgressCircle,
      WrapperVertical,
      WrapperHorizontal,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <ProgressBar value={100} failed mdxType="ProgressBar" />
    </Playground>
    <h3 {...{
      "id": "circle-2"
    }}>{`Circle`}</h3>
    <Playground __position={7} __code={'<ProgressCircle value={100} failed />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      ProgressBar,
      ProgressCircle,
      WrapperVertical,
      WrapperHorizontal,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <ProgressCircle value={100} failed mdxType="ProgressCircle" />
    </Playground>
    <h2 {...{
      "id": "circle-different-sizes"
    }}>{`Circle different sizes`}</h2>
    <Playground __position={8} __code={'<WrapperHorizontal>\n  <ProgressCircle value={50} circleSize={0} />\n  <ProgressCircle value={50} circleSize={25} />\n  <ProgressCircle value={50} circleSize={50} />\n  <ProgressCircle value={50} circleSize={75} />\n  <ProgressCircle value={50} circleSize={100} />\n</WrapperHorizontal>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      ProgressBar,
      ProgressCircle,
      WrapperVertical,
      WrapperHorizontal,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <WrapperHorizontal mdxType="WrapperHorizontal">
        <ProgressCircle value={50} circleSize={0} mdxType="ProgressCircle" />
        <ProgressCircle value={50} circleSize={25} mdxType="ProgressCircle" />
        <ProgressCircle value={50} circleSize={50} mdxType="ProgressCircle" />
        <ProgressCircle value={50} circleSize={75} mdxType="ProgressCircle" />
        <ProgressCircle value={50} circleSize={100} mdxType="ProgressCircle" />
    </WrapperHorizontal>
    </Playground>
    <h2 {...{
      "id": "custom-colors"
    }}>{`Custom colors`}</h2>
    <h3 {...{
      "id": "bar-3"
    }}>{`Bar`}</h3>
    <Playground __position={9} __code={'<WrapperVertical>\n  <ProgressBar value={25} transitionColors={[\'pink\', \'violet\', \'purple\']} />\n  <ProgressBar value={50} transitionColors={[\'pink\', \'violet\', \'purple\']} />\n  <ProgressBar value={75} transitionColors={[\'pink\', \'violet\', \'purple\']} />\n</WrapperVertical>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      ProgressBar,
      ProgressCircle,
      WrapperVertical,
      WrapperHorizontal,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <WrapperVertical mdxType="WrapperVertical">
        <ProgressBar value={25} transitionColors={['pink', 'violet', 'purple']} mdxType="ProgressBar" />
        <ProgressBar value={50} transitionColors={['pink', 'violet', 'purple']} mdxType="ProgressBar" />
        <ProgressBar value={75} transitionColors={['pink', 'violet', 'purple']} mdxType="ProgressBar" />
    </WrapperVertical>
    </Playground>
    <h3 {...{
      "id": "circle-3"
    }}>{`Circle`}</h3>
    <Playground __position={10} __code={'<WrapperHorizontal>\n  <ProgressCircle\n    value={25}\n    transitionColors={[\'pink\', \'violet\', \'purple\']}\n  />\n  <ProgressCircle\n    value={50}\n    transitionColors={[\'pink\', \'violet\', \'purple\']}\n  />\n  <ProgressCircle\n    value={75}\n    transitionColors={[\'pink\', \'violet\', \'purple\']}\n  />\n</WrapperHorizontal>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      ProgressBar,
      ProgressCircle,
      WrapperVertical,
      WrapperHorizontal,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <WrapperHorizontal mdxType="WrapperHorizontal">
        <ProgressCircle value={25} transitionColors={['pink', 'violet', 'purple']} mdxType="ProgressCircle" />
        <ProgressCircle value={50} transitionColors={['pink', 'violet', 'purple']} mdxType="ProgressCircle" />
        <ProgressCircle value={75} transitionColors={['pink', 'violet', 'purple']} mdxType="ProgressCircle" />
    </WrapperHorizontal>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      